// extracted by mini-css-extract-plugin
export default {"contentCards":"AutosFeedsListSkeleton-module-contentCards"};